import { RFEGlobalModule } from '../helpers/module';

/**
 * Helper module which copies text from field to clipboard and (optionally) displays element with the result message.
 * @todo    possible duplication of RFE.multimediaPlayerUtils.copyToClipboard
 *          VS: it's not duplication anymore, but it should be implemented into the player utils,
 *          but we might need to implement to multimediPlayer at some point
 */
export default class CopyToClipboard extends RFEGlobalModule {

    private navigatorClipboard = (navigator as any).clipboard;
    /**
     * Initialization of module. This module is expected to be used as single instance on page.
     * @return  {boolean}      TRUE/FALSE if the initialization was successful or not (boolean)
     */
    public initGlobal(): boolean {
        // the instance of module has been initialized => return TRUE
        return true;
    }

    /**
     * De-initialization of module
     */
    public deinitGlobal(): void { }

    /**
     * Initialization of the module inside of context
     * @param   {HTMLElement}   context   Parent element for searching target elements (HTMLElement)
     */
    public initContext(context: HTMLElement): void { }

    /**
     * De-initialization of module inside of context
     * @param   {HTMLElement}   context   Parent element for searching target elements (HTMLElement)
     */
    public deinitContext(context: HTMLElement): void { }

    /**
     * Copies text from field to clipboard and (optionally) displays element with the result message.
     * @param   {string}   elementId            id ID of HTML element to copy text from to clipboard (string)
     * @param   {string}   [messageId=null]     msg ID of element to display on successful copy (ignored if null) (string | null)
     * @todo    change messageId parameter from ID (string) to element (HTMLElement)
     */
    public copyToClipboard = async (element: HTMLInputElement | null, messageEL: HTMLElement | null = null): Promise<boolean> => {

        if (!element) {
            return false;
        }

        element.focus();
        element.setSelectionRange(0, element.value.length);

        let copySuccess: boolean = false; // var to check whether execCommand successfully executed

        if (document.queryCommandEnabled('copy') && !this.navigatorClipboard) {
            copySuccess = this.copyNoApi(copySuccess);
            this.showMessage(copySuccess, messageEL);
        } else if (this.navigatorClipboard) {
            copySuccess = await this.copyWithApi(element);
        } else {
            console.error('Can not copy to clipboard');
        }
        return Promise.resolve(copySuccess);
    }

    /**
     * for browsers which don't support Clipboard API (https://www.w3.org/TR/clipboard-apis/#async-clipboard-api
     */
    private copyNoApi = (copySuccess: boolean): boolean => {
        copySuccess = document.execCommand('copy'); // run command to copy selected text to clipboard
        return copySuccess;
    }

    // for browsers which do support Clipboard API
    private copyWithApi = async (inputElement): Promise<boolean> => {
        const result = await this.navigatorClipboard.writeText(inputElement.value).then(() => {
            return true;
        }, () => {
            console.error('Unable to write to clipboard.');
            return false;
        });
        return result;
    }

    /**
     * show message
     */
    private showMessage = (copySuccess: boolean, messageEl: HTMLElement | null): void => {
        if (copySuccess && messageEl) {
            messageEl.style.display = 'block';
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./source/js/modules/copy_to_clipboard.ts